import { FC } from 'react';
import { Button, Container, Typography } from '@mui/material';
import { useRouteError, useNavigate } from 'react-router-dom';
import { captureException } from '@sentry/react';

import { AuthRole } from '@libs/types';
import { routes } from '@carcareers/utils';
import { Appbar, Footer } from '@carcareers/components';
import { useAuth } from '@carcareers/hooks';

export const DefaultErrorBoundary: FC = () => {
  const { user } = useAuth();
  const error = useRouteError();
  const navigate = useNavigate();

  const redirects: Record<AuthRole, string> = {
    [AuthRole.SELF]: routes.HOME,
    [AuthRole.EMPLOYER]: `/${routes.HOME}/${routes.EMPLOYER_HOME}`,
    [AuthRole.JOBSEEKER]: `/${routes.HOME}/${routes.JOBSEEKER_HOME}`,
    [AuthRole.ADMIN]: `/${routes.HOME}/${routes.ADMIN_HOME}`,
  }
  const redirect = redirects[user?.role as AuthRole] || redirects[AuthRole.SELF];

  captureException(error, {
    contexts: {
      errorBoundary: {
        componentStack: 'DefaultErrorBoundary',
        errorBoundary: true,
      },
    },
  });

  return (
    <>
      <Appbar />
      <Container
        maxWidth="md"
        sx={{
          mt: { xs: 7, sm: 8 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'center',
          minHeight: { xs: 'calc(100vh - 160px)', sm: 'calc(100vh - 132px)' },
          gap: 4,
        }}
      >
        <Typography variant="h1">500</Typography>
        <Typography variant="h2">Woah! That took a wrong turn.</Typography>
        <Typography variant="body1">Please reroute to the home page.</Typography>
        <Button
          variant="contained"
          onClick={() => navigate(redirect)}
          sx={{
            backgroundColor: 'warning.light',
            color: 'warning.contrastText',
            '&:hover': {
              backgroundColor: 'warning.contrastText',
              color: 'background.default',
            },
          }}
        >
          Go Home
        </Button>
      </Container>
      <Footer />
    </>
  );
};

export default DefaultErrorBoundary;
